import React from 'react';
import { useIntl } from 'react-intl';
import { useCoreSelector, useCoreDispatch } from 'Contexts/StoreContext';
import { closeModal, selectCurrentModal } from 'Core_Redux/reminders';
import SuccessModal from './SuccessModal';
import { DELETE_SUCCESS } from './modals';

function DeleteReminderSuccessModal() {
  const intl = useIntl();
  const dispatch = useCoreDispatch();
  const currentModal = useCoreSelector(selectCurrentModal);

  const handleAcknowledge = () => dispatch(closeModal());

  return (
    <SuccessModal
      id={'ReminderDeleteSuccess'}
      open={currentModal == DELETE_SUCCESS}
      header={intl.formatMessage({ id: 'reminders.modal-delete-success-header' })}
      content={intl.formatMessage({ id: 'reminders.modal-delete-success-body' })}
      onClose={handleAcknowledge}
    />
  );
}

export default DeleteReminderSuccessModal;
